import { z } from 'zod'
import { richTextFromMarkdown } from '@contentful/rich-text-from-markdown'
import type { Document } from '@contentful/rich-text-types'

export const ContentfulCurrencyCodesSchema = z.enum(['EUR', 'GBP', 'USD', '999'])

export const ContentfulProductTypeSchema = z.enum(['HOTEL', 'EXPERIENCE', 'CAR_HIRE', 'FLIGHT'])

export type ContentfulProductType = z.infer<typeof ContentfulProductTypeSchema>

export const ContentfulDynamicVariableSchema = z.object({
  key: z.string(),
  defaultValue: z.string().optional(),
})

export type ContentfulDynamicVariable = z.infer<typeof ContentfulDynamicVariableSchema>

// used for rich text fields from contentful
// can normalise markdown set in long text fields
// optional: zod 4 rejects a missing key unless its schema is optional, zod 3 let z.any() through
export const ContentfulRichTextDocumentSchema = z
  .any()
  .optional()
  .transform(async (x) => {
    if (typeof x === 'string') {
      return (await richTextFromMarkdown(x)) as Document
    }
    return x as Document
  })

// Used for styling alto components with design tokens
export const ContentfulAltoTokenBackgroundSchema = z.enum([
  'base',
  'layer1',
  'layer2',
  'layer3',
  'accentVibrant',
  'accentSubtle',
  'accentDeep',
])

export type ContentfulAltoTokenBackground = z.infer<typeof ContentfulAltoTokenBackgroundSchema>

export const ContentfulAltoTokenVariantSchema = z.enum([
  'brand',
  'caution',
  'critical',
  'info',
  'neutral',
  'sale',
  'success',
  'warning',
  'white',
])

export type ContentfulAltoTokenVariant = z.infer<typeof ContentfulAltoTokenVariantSchema>
